"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePipCount = calculatePipCount;
/**
 * Calculates the pip count for a given player.
 * The pip count is the total number of pips (points) that a player must move
 * their checkers to bear them all off the board.
 *
 * @param gameState The current game state
 * @param playerColor The player color ('white' or 'black')
 * @returns The pip count for the specified player
 */
function calculatePipCount(gameState, playerColor) {
    var pipCount = 0;
    // Count checkers on the board
    for (var i = 0; i < gameState.board.length; i++) {
        var point = gameState.board[i];
        if (point.player === playerColor) {
            var pointNumber = void 0;
            if (playerColor === "white") {
                // White bears off at index 0, so distance from index i is (i + 1)
                pointNumber = i + 1;
            }
            else {
                // Black bears off at index 23, so distance from index i is (24 - i)
                pointNumber = 24 - i;
            }
            pipCount += point.count * pointNumber;
        }
    }
    // Add checkers on the bar
    // Bar checkers need to enter through opponent's home board and travel full distance
    // This is effectively 25 pips regardless of player color
    pipCount += gameState.bar[playerColor] * 25;
    // Note: Checkers that are borne off (in gameState.off) contribute 0 to pip count
    return pipCount;
}
//# sourceMappingURL=pipCounter.js.map